import React, { useState } from 'react';
import { FaSpinner } from "react-icons/fa";

const ComplaintQueryModal = ({ isOpen, onClose, onQuery, loading }) => {
    const [phone, setPhone] = useState("");
    const [complaintId, setComplaintId] = useState("");
    const [error, setError] = useState("");

    const convertToEnglishNums = (str) => {
        return str.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
            .replace(/[۰-۹]/g, (d) => "۰۱۲۳٤٥٦۷۸۹".indexOf(d));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");

        const cleanPhone = convertToEnglishNums(phone).trim().replace(/\s/g, '');
        const cleanId = convertToEnglishNums(complaintId).trim();

        if (cleanPhone.length !== 10 || !cleanPhone.startsWith("09")) {
            setError("يرجى ادخال رقم صحيح");
            return;
        }

        onQuery(cleanPhone, cleanId);
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="complaint-custom-overlay" onClick={onClose}>
                <div className="complaint-custom-modal shadow-lg" onClick={e => e.stopPropagation()}>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="m-0 text-info fw-bold">الاستعلام عن شكوى</h4>
                        <button className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        {error && <div className="alert alert-danger py-2 small mb-3 text-center">{error}</div>}

                        <div className="mb-3 text-end">
                            <label className="form-label small text-white-50">رقم الهاتف</label>
                            <input
                                type="text"
                                className="form-control query-input fw-bold text-center"
                                placeholder="09xxxxxxxx"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                maxLength={10}
                                required
                            />
                        </div>

                        <div className="mb-4 text-end">
                            <label className="form-label small text-white-50">رقم الشكوى</label>
                            <input
                                type="text"
                                className="form-control query-input text-center"
                                placeholder="أدخل رقم الشكوى هنا"
                                value={complaintId}
                                onChange={(e) => setComplaintId(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="btn btn-info w-100 rounded-pill fw-bold py-2 shadow" disabled={loading}>
                            {loading ? <FaSpinner className="spinner-icon" /> : "استعلام الآن"}
                        </button>
                    </form>
                </div>
            </div>

            <style>{`
                .complaint-custom-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(15, 23, 42, 0.85);
                    backdrop-filter: blur(8px);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                }
                .complaint-custom-modal {
                    background: #1e293b;
                    width: 90%;
                    max-width: 400px;
                    padding: 30px;
                    border-radius: 25px;
                    border: 1px solid rgba(56, 189, 248, 0.3);
                    box-shadow: 0 20px 50px rgba(0,0,0,0.5);
                }
                .query-input {
                    background: rgba(15, 23, 42, 0.5) !important;
                    border: 1px solid rgba(255,255,255,0.1) !important;
                    color: white !important;
                    border-radius: 12px;
                    padding: 12px;
                }
                
                /* تحسين وضوح البليس هولدر */
                .query-input::placeholder {
                    color: rgba(255, 255, 255, 0.78) !important;
                    font-weight: normal;
                    font-size: 0.9rem;
                }

                /* لضمان العمل على متصفحات Safari/Chrome القديمة */
                .query-input::-webkit-input-placeholder { color: rgba(255, 255, 255, 0.4); }
                .query-input::-moz-placeholder { color: rgba(255, 255, 255, 0.4); }

                .spinner-icon { animation: spin 1s linear infinite; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
            `}</style>
        </>
    );
};

export default ComplaintQueryModal;